const generateID = () => {
    return Date.now() + Math.random()
}

export default generateID